import React from 'react';

import type { ChallengeType } from '../types';

const INSTRUCTIONS: Record<ChallengeType, { title: string; detail: string }> = {
  head_turn_left: {
    title: 'Vire a cabeça para a esquerda',
    detail: 'Mantenha o rosto no quadro enquanto gira suavemente.',
  },
  head_turn_right: {
    title: 'Vire a cabeça para a direita',
    detail: 'Mantenha o rosto no quadro enquanto gira suavemente.',
  },
  pitch_up: {
    title: 'Incline a cabeça para cima',
    detail: 'Erga o queixo levemente, como se olhasse para o teto.',
  },
  pitch_down: {
    title: 'Incline a cabeça para baixo',
    detail: 'Abaixe o queixo levemente, como se olhasse para o chão.',
  },
  blink: {
    title: 'Pisque os olhos duas vezes',
    detail: 'Faça duas piscadas completas e naturais.',
  },
  mouth_open: {
    title: 'Abra a boca',
    detail: 'Abra bem a boca e mantenha por um instante.',
  },
};

interface ChallengeInstructionProps {
  type: ChallengeType;
  variant?: 'default' | 'mobile';
}

export const ChallengeInstruction: React.FC<ChallengeInstructionProps> = ({
  type,
  variant = 'default',
}) => {
  const content = INSTRUCTIONS[type];
  const isMobile = variant === 'mobile';

  return (
    <div
      className={`mx-auto max-w-xl rounded-[1.5rem] border border-white/10 bg-white/5 shadow-[0_12px_50px_rgba(15,23,42,0.28)] backdrop-blur-sm ${
        isMobile ? 'px-4 py-4 text-left' : 'px-6 py-5 text-center'
      }`}
    >
      <p
        className={`font-semibold uppercase text-cyan-300 ${
          isMobile
            ? 'text-[10px] tracking-[0.24em]'
            : 'text-xs tracking-[0.35em]'
        }`}
      >
        Instrução atual
      </p>
      <p
        className={`mt-2 font-semibold leading-tight text-white ${
          isMobile ? 'text-[1.85rem]' : 'text-2xl'
        }`}
      >
        {content.title}
      </p>
      <p
        className={`mt-2 leading-6 text-slate-300 ${
          isMobile ? 'text-base' : 'text-sm'
        }`}
      >
        {content.detail}
      </p>
    </div>
  );
};
